import React, { Component } from 'react';
import ReservationInformation from './reservationInformation';
import UserReserver from './userReserver';
import Buttons from './buttons';
import 'moment/locale/es'
import moment from 'moment';
class Form extends Component {
    constructor() {
        super()
        this.state = {
            city: '',
            roomType: '',
            persons: '',
            incomingDate: moment(),
            outcomingDate: moment(),
            owner: '',
            phone: '',
            email: ''
        }
    }

    justSetValuesInState = (ref, val) => {
        this.setState({ [ref]: val });
    }
    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    handleChangeInDate = (date) => {
        this.setState({ incomingDate: moment(date) });
    };

    handleChangeOutDate = (date) => {
        this.setState({ outcomingDate: moment(date) });
    };

    submitForm = () => {
        var data = JSON.stringify(this.state);
        // var data = this.state;
        // console.log(data)
        console.log(typeof data);
        fetch(`https://us-central1-puestadorada-8a9f6.cloudfunctions.net/sendMail?data=${encodeURIComponent(data)}`)
            .then(response => {
                console.log(response);
                // alert('')
                return response
            })
        this.props.closeModal();
    }

    render() {
        return (
            <div>
                <ReservationInformation
                    state={this.state}
                    justSetValuesInState={this.justSetValuesInState}
                    handleChange={this.handleChange}
                    handleChangeInDate={this.handleChangeInDate}
                    handleChangeOutDate={this.handleChangeOutDate}
                />
                <UserReserver
                    state={this.state}
                    handleChange={this.handleChange}
                    handleChangeInDate={this.handleChangeInDate}
                    handleChangeOutDate={this.handleChangeOutDate}
                />
                <Buttons
                    state={this.state}
                    closeModal={this.props.closeModal}
                    submitForm={this.submitForm}
                />
            </div>
        );
    }
}
export default Form;